var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:(_vm.getLinkStyles),attrs:{"href":_vm.getLink,"title":_vm.tooltipTitle,"target":_vm.getTargetBlank}},[_c('img',{style:(_vm.getImgStyles),attrs:{"src":_vm.getIcon,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }